<template>
  <div>
    <div class="content">
      <img
        src="../../assets/img/succese.png"
        alt
        class="icon-img"
      />
      <p>提现申请已提交</p>
      <p>预计{{info.paymentDate}}前到账</p>
    </div>
    <div class="common">
      <p class="flex-between van-hairline--bottom">
        <span>储蓄卡</span>
        <span>{{info.bankName}} 尾号 {{info.cardNum}}</span>
      </p>
    </div>
    <div class="common">
      <p class="flex-between">
        <span>提现金额</span>
        <span>¥{{info.tranAmount}}</span>
      </p>
    </div>
    <van-button
      class="btn"
      text="完成"
      block
      @click="closeHandsel"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      info: {},
    };
  },
  methods: {
    closeHandsel() {
      if (this.$store.getters.ambientType == 0) {
        wx.miniProgram.navigateBack({ delta: 9999 });
      } else if (this.$store.getters.ambientType == 1) {
        window.Android.closeHandsel();
      } else if (this.$store.getters.ambientType == 2) {
        window.webkit.messageHandlers.closeHandsel.postMessage("");
      }
    },
  },
  mounted() {
    this.info = JSON.parse(this.$route.params.info);
  },
  beforeRouteLeave(to, from, next) {
    if (to.path == "/e_extractCode") {
      this.closeHandsel();
    } else {
      next();
    }
  },
};
</script>

<style lang="scss" scoped>
.content {
  height: 169px;
  padding-top: 37px;
  text-align: center;
  .icon-img {
    width: 65px;
    height: 65px;
    margin: 0 auto;
    display: block;
  }
  p:first-of-type {
    font-size: 17px;
    font-weight: bold;
    margin-top: 14px;
  }
  p:last-of-type {
    font-size: 14px;
    color: #999999;
    margin-top: 3px;
  }
}
.common {
  height: 44px;
  line-height: 44px;
  padding: 0 12px;
  background-color: #ffffff;
  span:first-of-type {
    font-size: 14px;
    color: #999999;
  }
  span:last-of-type {
    font-size: 14px;
    font-weight: bold;
  }
}
.btn {
  width: 343px;
  height: 40px;
  font-size: 16px;
  margin: 28px 16px 0;
  background-color: #50BE4C;
  border-radius: 5px;
  font-size: 17px;
  color: #ffffff;
  border-radius: 50px;
}
</style>